module.exports = __webpack_public_path__ + "img/3 Blick in den Sall leer.jpg";